import { createContext } from 'react';

const DefaultValues = {
    token: null,
    userInfo: null,
};

export const AppContext = createContext(DefaultValues);